import React from "react"
import {
  actualiteInfos,
  actualiteImgContainer,
  actualiteCategorie,
  actualiteTitle,
  actualiteResume,
  actualiteContainerFirst,
} from "../actualites.module.scss"
import NonStretchedImage from "gatsby-theme-blank/src/components/Image/non-stretched-image"
import SummaryTransformer from "gatsby-theme-blank/src/components/Transformers/summary-transformer"
import { summaryLength } from "gatsby-theme-blank/src/constants"
import { Taxo, Link } from "./actu-item-styled"
import PropTypes from "prop-types"

const ActuItem = ({ actu, myClassName }) => {
  let image = ""
  let title = ""
  if (myClassName === actualiteContainerFirst) {
    image = (
      <div className={actualiteImgContainer}>
        <NonStretchedImage
          {...actu.relationships.field_image_actus?.localFile}
          ariaHidden={true}
        />
      </div>
    )
  } else {
    image = (
      <div className={actualiteImgContainer}>
        <NonStretchedImage
          {...actu.relationships.field_image_actus?.localFile}
          ariaHidden={true}
        />
      </div>
    )
  }
  title = actu.title
  return (
    <div className={myClassName}>
      {actu.relationships.field_image_actus?.localFile && <>{image}</>}
      <div className={actualiteInfos}>
        <h3 className={actualiteTitle}>{title}</h3>
        {actu.relationships.field_taxonomie_thematique?.length > 0 && (
          <div className={actualiteCategorie}>
            <Taxo>
              Thématique :{" "}
              <span>
                {actu.relationships.field_taxonomie_thematique[0].name}
              </span>
            </Taxo>
          </div>
        )}
        {actu.body && (
          <p
            className={actualiteResume}
            dangerouslySetInnerHTML={{
              __html: SummaryTransformer(actu.body, summaryLength),
            }}
          />
        )}
        <Link tabIndex={-1}>
          Voir l&apos;article
          <span aria-hidden={true}> &rarr;</span>
        </Link>
      </div>
    </div>
  )
}

ActuItem.propTypes = {
  actu: PropTypes.object.isRequired,
  myClassName: PropTypes.string.isRequired,
  colors: PropTypes.object,
}

export default ActuItem
